<template lang="pug">
  el-container
    el-header(height="auto")
      el-form(inline label-suffix=":")
        city-select(v-model="cityGuid" @change="getCityName" @show="changeShow")
        v-date-picker(v-model="timeRange" @setTime="changeTime")
        el-form-item
          el-button.custom--el-button(
            type="primary"
            icon="el-icon-search"
            @click="search"
            :disabled="!cityGuid || timeRange.length === 0"
            :loading="searchFlag"
          ) 搜索
    el-main(style="overflow:visible")
      //- 第一例卡片
      el-row.row-just(:gutter="20" v-for="(rowItem, rowKey) in statAndAvgData" :key="rowKey")
        el-col(:span="6" v-for="(colItem,colKey) in rowItem" :key="colKey")
          .card-stat-data
            p.card-stat-data--title {{colItem.title}}
            p.card-stat-data--num {{colItem.stat}}
      //- 第二列卡片
      .card-avg-data
        .card-avg-data--container(
          v-for="(consumerStatItem,consumerStatKey) in consumerStat"
          :key="consumerStatKey"
        )
          h3.card-avg-data--header {{consumerStatItem.title}}
          el-row.card-avg-data--main(:gutter="62")
            el-col(
              :span="8"
              v-for="(childrenItem,childrenKey) in consumerStatItem.children"
              :key="childrenKey"
            )
              .card-avg-data--card-content
                .card-avg-data--card-text {{childrenItem.title}}
                el-popover(placement="top" trigger="hover")
                  div {{childrenItem.num}}
                  span.card-avg-data__span--num(slot="reference") {{childrenItem.num | filterNum}}
                img.card-avg-data--card-img(:src="childrenItem.imgSrc")
          .line
      //- 图表
      el-row.row-just2(
        :gutter="50"
        v-for="(charsStatItem,charsStatKey) in chartsStat"
        :key="charsStatKey"
      )
        el-col(:span="12" v-for="(colItem,colKey) in charsStatItem" :key="colKey")
          .echarts--container
            .echarts--header
              img(:src="colItem.imgSrc")
              span {{colItem.title}}
            v-charts(:option="colItem.option" width="100%" height="438px")
</template>
<script>
import vCharts from '@/components/v-charts';
import citySelect from '@/components/citySelect';
import getReportData from '@/api/bikeDataReport';
import vDatePicker from './components/v-date-picker';

export default {
  components: {
    vCharts,
    vDatePicker,
    citySelect
  },
  filters: {
    filterNum(value) {
      const num = parseFloat(value);
      const str = String(value).replace(`${num}`, '');
      if (String(num).length > 8) {
        return `${(num / 100000000).toFixed(0)}亿${str}`;
      }
      if (String(num).length > 4) {
        return `${(num / 10000).toFixed(0)}万${str}`;
      }
      return value;
    }
  },
  data() {
    return {
      timeRange: [],
      cityGuid: '',
      cityName: '',
      searchFlag: false,
      statAndAvgData: [],
      consumerStat: [],
      chartsStat: [],
    };
  },
  methods: {
    changeTime() {
      this.search();
    },
    getSearchFrom() {
      return {
        cityGuid: this.cityGuid,
        startDate: this.timeRange[0] || '',
        endDate: this.timeRange[1] || ''
      };
    },
    getSeriesData(data) {
      return Object.keys(data).map(name => ({
        name,
        value: data[name]
      }));
    },
    fommater(value) {
      let sign = '';
      let tempValue = value;
      if (value[1] === '-') {
        tempValue = value.slice(1);
        sign = '-';
      }
      tempValue = String(tempValue).trim().split('').reverse()
        .join('')
        .replace(/(\d{3})(?=[^$])/g, '$1,')
        .split('')
        .reverse()
        .join('');
      return sign + tempValue;
    },
    getCityName(city) {
      this.cityName = city.cityName;
    },
    changeShow(show) {
      if (!show) {
        this.search();
      }
    },
    async search() {
      if (!this.cityGuid || !this.timeRange.length || this.searchFlag) return;
      this.searchFlag = true;
      let res;
      try {
        res = await getReportData(this.getSearchFrom());
      } finally {
        this.searchFlag = false;
      }
      const { data } = res;
      data.rideDetailList = data.rideDetailList.sort((a, b) => a.day.replace(/-/g, '') - b.day.replace(/-/g, ''));
      this.statAndAvgData = [
        [
          {
            title: '累计骑行次数(次)',
            stat: this.fommater(data.totalRideCount)
          }, {
            title: '累计骑行距离(m)',
            stat: this.fommater(data.totalRideDistance)
          }, {
            title: `出行高峰日(${data.topDay})(次)`,
            stat: this.fommater(data.topCount)
          }, {
            title: '累计投放车辆数(辆)',
            stat: this.fommater(data.totalBikeCount)
          }
        ], [
          {
            title: '人均日出行次数(次)',
            stat: this.fommater(data.avgRideCount)
          }, {
            title: '人均日出行距离(m)',
            stat: this.fommater(data.avgRideDistance)
          }, {
            title: '人均日出行时长(min)',
            stat: this.fommater(data.avgRideTime)
          }, {
            title: '人均出行速度(km/h)',
            stat: this.fommater(data.avgRideSpeed)
          }
        ]
      ];
      this.consumerStat = [
        {
          title: `通过骑行,相当于为${this.cityName}贡献了`,
          children: [
            {
              imgSrc: require('../../assets/data_icon_metro.png'),
              title: '地铁载客量',
              num: `${data.metroCount}列`
            },
            {
              imgSrc: require('../../assets/data_icon_bus.png'),
              num: `${data.busCount}辆`,
              title: '公交载客量'
            },
            {
              imgSrc: require('../../assets/data_icon_taxi.png'),
              num: `${data.taxiCount}辆`,
              title: '出租车载客量'
            }
          ]
        },
        {
          title: `通过骑行,相当于为${this.cityName}`,
          children: [
            {
              imgSrc: require('../../assets/data_icon_CO2.png'),
              num: `${data.carbonEmissions}吨`,
              title: '减少碳排放'
            },
            {
              imgSrc: require('../../assets/data_icon_heat.png'),
              num: `${data.calorie}千卡`,
              title: '消耗热量'
            },
            {
              imgSrc: require('../../assets/data_icon_tree.png'),
              num: `${data.trees}棵`,
              title: '植树'
            }
          ]
        },
      ];
      this.chartsStat = [
        [
          {
            imgSrc: require('../../assets/data_icon_age.png'),
            title: '用户年龄分布',
            option: {
              tooltip: {
                trigger: 'item',
                formatter: '{a} <br/>{b} : {d}%'
              },
              series: [
                {
                  name: '用户年龄分布',
                  type: 'pie',
                  radius: ['10%', '55%'],
                  roseType: 'radius',
                  data: [
                    {
                      name: '12-17',
                      value: data.rideAgeDistribution && data.rideAgeDistribution['12-17']
                    }, {
                      name: '18-23',
                      value: data.rideAgeDistribution && data.rideAgeDistribution['18-23']
                    }, {
                      name: '24-28',
                      value: data.rideAgeDistribution && data.rideAgeDistribution['24-28']
                    }, {
                      name: '29-35',
                      value: data.rideAgeDistribution && data.rideAgeDistribution['29-35']
                    }, {
                      name: '36-40',
                      value: data.rideAgeDistribution && data.rideAgeDistribution['36-40']
                    }, {
                      name: '41-60',
                      value: data.rideAgeDistribution && data.rideAgeDistribution['41-60']
                    }, {
                      name: '61+',
                      value: data.rideAgeDistribution && data.rideAgeDistribution['61+']
                    }
                  ],
                  itemStyle: {
                    emphasis: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                  }
                }
              ]
            }
          },
          {
            imgSrc: require('../../assets/data_icon_gender.png'),
            title: '用户性别分布',
            option: {
              tooltip: {
                trigger: 'item',
                formatter: '{a} <br/>{b} : {d}%'
              },
              series: [
                {
                  name: '用户性别分布',
                  type: 'pie',
                  radius: '55%',
                  data: [
                    {
                      name: '男',
                      value: data.rideSexDistribution && data.rideSexDistribution.male
                    }, {
                      name: '女',
                      value: data.rideSexDistribution && data.rideSexDistribution.female
                    }
                  ],
                  itemStyle: {
                    emphasis: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                  }
                }
              ]
            }
          }
        ],
        [
          {
            imgSrc: require('../../assets/data_icon_time.png'),
            title: '出行次数统计',
            option: {
              tooltip: {
                trigger: 'axis',
              },
              xAxis: [
                {
                  type: 'category',
                  axisLine: false,
                  data: data.rideDetailList.map(v => v.day),
                }
              ],
              grid: {
                left: '90',
                right: '90'
              },
              yAxis: [
                {
                  type: 'value',
                  name: '出行次数',
                  axisLabel: {
                    formatter: '{value} 次'
                  },
                }
              ],
              series: [
                {
                  name: '出行次数',
                  type: 'line',
                  data: data.rideDetailList.map(v => v.successOrderCount),
                  lineStyle: {
                    color: 'red'
                  }
                }
              ]
            }
          },
          {
            imgSrc: require('../../assets/data_icon_distance.png'),
            title: '出行距离分布',
            option: {
              tooltip: {
                trigger: 'item',
                formatter: '{a} <br/>{b} : {d}%'
              },
              series: [
                {
                  name: '出行距离分布',
                  type: 'pie',
                  radius: '55%',
                  data: [
                    {
                      name: '0-200m',
                      value: data.rideDistanceDistribution && data.rideDistanceDistribution['0-200m']
                    }, {
                      name: '200-500m',
                      value: data.rideDistanceDistribution && data.rideDistanceDistribution['200-500m']
                    }, {
                      name: '500-1000m',
                      value: data.rideDistanceDistribution && data.rideDistanceDistribution['500-1000m']
                    }, {
                      name: '1-3km',
                      value: data.rideDistanceDistribution && data.rideDistanceDistribution['1-3km']
                    }, {
                      name: '3-5km',
                      value: data.rideDistanceDistribution && data.rideDistanceDistribution['3-5km']
                    }, {
                      name: '5km+',
                      value: data.rideDistanceDistribution && data.rideDistanceDistribution['5km+']
                    },
                  ],
                  itemStyle: {
                    emphasis: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                  }
                }
              ]
            }
          }
        ]
      ];
    }
  }
};
</script>
<style lang="less" scoped>
  p,h1,h2,h3{
    margin:0px;
    padding: 0px;
  }
  .row-just:nth-child(2){
    margin-top: 30px;
  }
  .row-just:nth-child(1){
    margin-top: 10px;
  }
  .card-stat-data{
    width: 100%;
    .card-stat-data--title{
      font-size:14px;
      font-family:PingFangSC-Regular;
      font-weight:400;
      color:rgba(76,82,117,1);
      line-height:14px;
    }
    .card-stat-data--num{
      margin-top:10px;
      height:42px;
      font-size:36px;
      font-family:HelveticaNeue-Medium;
      font-weight:500;
      color:rgba(255,255,255,1);
      line-height:42px;
    }
  }

  .card-avg-data {
    background: #202335;
    border-radius: 8px;
    padding:0 50px;
    margin-top: 60px;
    .card-avg-data--container:nth-child(2) .line{
      border:none;
    }
  }
  .card-avg-data--header{
    font-size:26px;
    font-family:PingFangSC-Regular;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height:26px;
    padding:50px 0;
  }
  .card-avg-data--card-content{
    width: 100%;
    padding:52px 0;
    padding-right: 30px;
    background: #252940;
    position: relative;
    // text-indent: 162px;
    text-align: right;
    border-radius: 8px;
  }
  .card-avg-data--card-img{
    position: absolute;
    top:50%;
    transform: translateY(-50%);
    left:15px;
    width: 78px;
    height:78px;
    // float: right;
    margin-right: 26px;
  }
  // .card-avg-data--content{
  //   float:right;
  //   max-width:218px ;
  //   min-width: 218px;
  // }
  .card-avg-data--card-text{
    height:22px;
    font-size:16px;
    font-family:PingFangSC-Regular;
    font-weight:400;
    color:rgba(105,116,163,1);
    line-height:22px;
  }
  .card-avg-data__span--num{
    height:50px;
    font-size:30px;
    font-family:PingFangSC-Medium;
    font-weight:500;
    color:rgba(255,255,255,1);
    line-height:50px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    margin-top:10px;
  }
  .line{
    height:50px;
    border-bottom: 2px solid #252940;
  }
  .row-just2{
    margin: 50px;
  }
  .echarts--container{
    width:100%;
    height:540px;
    border-radius: 10px;
    background: #222437;
  }
  .echarts--header{
    display: flex;
    align-items: center;
    font-family:PingFangSC-Regular;
    height: 102px;
    font-size:24px;
    padding-left:50px;
    background: #282A3F;
    color: white;
    border-radius: 10px;
    border-bottom-left-radius:0px;
    border-bottom-right-radius: 0px;
    img{
      width:30px;
      height:30px;
    }
    span{
      margin-left: 30px;
    }
  }
  .custom--el-button{
    margin-left:20px;
  }
</style>




// WEBPACK FOOTER //
// src/views/dataCenter/bikeDataReport.vue?e18e530a